/** Launch UPI apps — Paytm cash_wallet merchant intent (mode=02 + MCC) avoids wallet/CC blocks on @ptsbi. */

function isAndroid() {
  return /android/i.test(typeof navigator !== "undefined" ? navigator.userAgent || "" : "");
}

function paytmLaunchUrl(paytmmpUrl) {
  const url = (paytmmpUrl || "").trim();
  if (!url.startsWith("paytmmp://")) return url;
  if (!isAndroid()) return url;
  const pathAndQuery = url.slice("paytmmp://".length);
  return `intent://${pathAndQuery}#Intent;scheme=paytmmp;package=net.one97.paytm;end`;
}

function gpayAndroidIntent(gpayUrl) {
  const url = (gpayUrl || "").trim();
  if (!url.startsWith("tez://")) return url;
  const path = url.slice("tez://".length);
  return `intent://${path}#Intent;scheme=tez;package=com.google.android.apps.nbu.paisa.user;end`;
}

function phonePeAndroidIntent(phonepeUrl) {
  const url = (phonepeUrl || "").trim();
  if (!url.startsWith("phonepe://")) return url;
  const path = url.slice("phonepe://".length);
  return `intent://${path}#Intent;scheme=phonepe;package=com.phonepe.app;end`;
}

function launchUrl(url) {
  if (!url) return false;
  try {
    const a = document.createElement("a");
    a.href = url;
    a.rel = "noopener noreferrer";
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return true;
  } catch {
    try {
      window.location.href = url;
      return true;
    } catch {
      return false;
    }
  }
}

export function customerPayUrls(paymentDue) {
  if (!paymentDue) return {};
  return {
    paytmCashWallet: (paymentDue.paytm_cash_wallet_url || paymentDue.paytm_pay_url || "").trim(),
    paytmMobile: (paymentDue.paytm_mobile_pay_url || "").trim(),
    gpay: (paymentDue.gpay_pay_url || "").trim(),
    phonepe: (paymentDue.phonepe_pay_url || "").trim(),
    upi: (paymentDue.upi_pay_url || "").trim(),
  };
}

/** Paytm merchant collect — cash_wallet + money_transfer (bank UPI, not wallet-only collect). */
export function openCustomerPaytm(paymentDue) {
  const { paytmCashWallet, paytmMobile } = customerPayUrls(paymentDue);
  const raw = paytmCashWallet || paytmMobile;
  if (!raw) return false;
  return launchUrl(paytmLaunchUrl(raw));
}

export function openCustomerGPay(paymentDue) {
  const { gpay, upi } = customerPayUrls(paymentDue);
  const raw = gpay || upi;
  if (!raw) return false;
  const url = isAndroid() && gpay ? gpayAndroidIntent(gpay) : raw;
  return launchUrl(url);
}

export function openCustomerPhonePe(paymentDue) {
  const { phonepe, upi } = customerPayUrls(paymentDue);
  const raw = phonepe || upi;
  if (!raw) return false;
  const url = isAndroid() && phonepe ? phonePeAndroidIntent(phonepe) : raw;
  return launchUrl(url);
}
